import React, { Fragment, useContext, useState, useEffect } from "react";
import { Form, Modal, Button, Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import Email from "../inputs/Email";
import $ from "jquery";
import { validateEmail } from "../../commonData";
import ReCAPTCHA from "react-google-recaptcha";

const ModalWithEmail = (props) => {
    const { onClose, onProceed, translate, show, blockForm } = props;
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [token, setToken] = useState(null);
    const { setAlerts, theme } = useContext(BasicContext);

    const handleValidation = (e) => {
        e.preventDefault();
        const errors = [];
        if (!email.replace("^s+$", "")) {
            $("#resetPassEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else if (!validateEmail(email)) {
            $("#resetPassEmail").addClass("is-invalid");
            errors.push(t("error.invalidEmail"));
        }
        if (!token) errors.push(t("error.noCaptcha"));

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.sendingEmail") }]);
            onProceed({ username: email, token: token });
        }
    };

    useEffect(() => {
        setAlerts([]);
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Modal show={show} onHide={onClose}>
                <Form>
                    <Modal.Header closeButton>
                        <Modal.Title>{t(`${translate}.title`)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <p className="mb-3">{t(`${translate}.txt`)}</p>
                                    <Email value={email} onChange={(e) => setEmail(e.target.value)} id="resetPassEmail" />
                                </Col>
                                <Form.Group>
                                    <Col xs={12} className="text-center my-3" id="recaptcha">
                                        <ReCAPTCHA sitekey={process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY} onChange={(value) => setToken(value)} theme={theme} />
                                    </Col>
                                </Form.Group>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" variant="primary" onClick={handleValidation} disabled={blockForm || !email}>
                            {t(`${translate}.proceedTxt`)}
                        </Button>
                        <Button variant="outline-primary" onClick={props.onClose}>
                            {t(`${translate}.cancelTxt`)}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default ModalWithEmail;
